import React from 'react';

const Prepayment = React.lazy(() => import('../../modules/prepayment'));
const AdvancePayment = React.lazy(() => import('../../modules/prepayment/pages/AdvancePayment'));
const ProdCostPaymentRecord = React.lazy(() => import('../../modules/prepayment/pages/ProdCostPaymentRecord'));
const PaymentDetail = React.lazy(() => import('../../modules/prepayment/pages/PaymentDetail'));

export const prepaymentConfigs = [
  {
    path: '/prepayment',
    element: <Prepayment />,
  },
  {
    path: 'advancePayment',
    element: <AdvancePayment />,
  },
  {
    path: 'advancePayment/detail',
    element: <PaymentDetail />,
  },
  {
    path: 'prodCostPaymentRecord',
    element: <ProdCostPaymentRecord />,
  },
];
